<template>
  <Layout>
    <div class="section  content is-size-7">
      <p class="is-size-5">Cancelation</p>
      <div v-if="state === 'open'">
        <p>To cancel your subscription, please send UNSUB KYF to 70080. Or use button bellow</p>
        <button class="button p-l-lg p-r-lg" @click="cancel">Cancel subscription</button>
      </div>
      <p v-else>Subscription successfuly closed.</p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'
import axios from 'axios'

export default {
  name: 'Deactivation',
  data() {
    return {
      saleId: null,
      state: 'open'
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      this.saleId = window.localStorage.getItem('saleId') 
    }
  },
  methods: {
    async cancel () {
      const res = await axios.get(`/tpay/cl/${ this.saleId }`)
        .catch(() => { return { data: { state: 'error' } } })
      if (res.data.error === undefined) {
        this.state = 'closed'
      } else {
        this.state = 'error'
      }
    }
  },
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/KE/Deactivation.vue